// extracted by mini-css-extract-plugin
export default {"unreadScansTable":"T_ofZmP0_J_WHkj48nfM"};